(function() {
    const iframeEls = document.querySelectorAll('.default-styles iframe');

    [...iframeEls].forEach(el => setIframeAspectRatio(el, [16, 9]));
    window.addEventListener('resize', _ => [...iframeEls].forEach(el => setIframeAspectRatio(el, [16, 9])));
})();

function setIframeAspectRatio(el, aspectRatio) {
    el.style.height = ((el.offsetWidth / aspectRatio[0]) * aspectRatio[1]) + 'px';
}